import React from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import { ReactSVG } from 'react-svg'
import { observer } from 'mobx-react-lite'
import { ConfigStore } from '../store/configStore'
import { cloneDeep } from 'lodash-es'

export interface NavigationItem {
  label: string
  path: string
  icon?: string
  active?: () => boolean
}

const MAIN_ITEM = (): NavigationItem => ({
  label: 'Главная',
  path: '/',
  icon: 'layout-grid'
})

const NAVIGATION_ITEMS = (): NavigationItem[] =>
  [MAIN_ITEM()].concat([
    {
      label: 'Мероприятия',
      path: '/events',
      icon: 'calendar'
    },
    {
      label: 'Сообщества',
      path: '/communities',
      icon: 'users-group'
    },
    // {
    //   label: 'Портфолио',
    //   path: '/portfolio',
    //   icon: 'file-certificate'
    // },
    {
      label: 'Рейтинг',
      path: '/rating',
      icon: 'rating-outline'
    },
    {
      label: 'Награды',
      path: '/rewards',
      icon: 'trophy'
    },
    {
      label: 'Партнеры',
      path: '/partners',
      icon: 'briefcase'
    }
  ])

const Navigation = observer(
  ({
    className,
    onClick
  }: {
    className?: string
    onClick?: React.MouseEventHandler<HTMLButtonElement> &
      React.MouseEventHandler<HTMLAnchorElement>
  }) => {
    const location = useLocation()
    const items = React.useMemo(() => {
      let res: NavigationItem[] = []

      if (ConfigStore.privateConfig?.navigation?.length) {
        res = [MAIN_ITEM()].concat(
          cloneDeep(ConfigStore.privateConfig.navigation)
        )
      } else {
        res = NAVIGATION_ITEMS()
      }

      return res
        .filter((item) => item.path !== '/portfolio')
        .map((item, index) => {
          if (!index) {
            item.active = () => location.pathname === item.path
          } else {
            item.active = () => location.pathname.startsWith(item.path)
          }

          return item
        })
    }, [ConfigStore.privateConfig, location])

    return (
      <nav className={`navigation ${className ?? ''}`.trim()}>
        {items.map(({ label, path, icon, active }) => (
          <Link
            onClick={onClick}
            to={path}
            key={path}
            className={`navigation__link ${active?.() ? '_active' : ''}`.trim()}
          >
            <ReactSVG
              className={'svg-icon'}
              src={`/i/svg/${icon}.svg`}
              wrapper={'span'}
            ></ReactSVG>
            <span>{label}</span>
          </Link>
        ))}
      </nav>
    )
  }
)

export default Navigation
